import { useSelector } from 'react-redux';
import { getIsLojinha } from '../../authSlice/authSelectors';

function useIsPlanLojinha(): boolean {
  return useSelector(getIsLojinha);
}

export default useIsPlanLojinha;
